







import { topupProviderCreditTransactionsController } from '@/api/Topup/topup.api'
import TransactionsView from '@/components/TransactionsView.vue'
import { TopUpProviderCreditTransactionTypes } from '@/utils/interfaces/topup.interface'
import Vue from 'vue'
export default Vue.extend({
  components: {
    TransactionsView,
  },
  data() {
    return {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      types: this.$utils.makeSelectable(TopUpProviderCreditTransactionTypes),
      controller: topupProviderCreditTransactionsController,
    }
  },
})
